import React, { useState } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Row,
  Col,
  Alert
} from "reactstrap";
import { AvForm, AvField } from "availity-reactstrap-validation";
import { bindActionCreators, compose } from "redux";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import DatePicker from "react-datepicker";
import { cs, enGB } from 'date-fns/locale'
import "react-datepicker/dist/react-datepicker.css";

import { orderAction } from "../../_actions";


class PayOrderModal extends React.Component<
  {
    buttonLabel: any;
    id: any;
    variableSymbol: any;
    price: any;
    currency: any;
    name: any;
    canceled: boolean;
    style?: any;
    icon?: any;
  },
  any
> {
  constructor(props: any) {
    super(props);
    const i18nextLng = localStorage.getItem("i18nextLng");

    this.state = {
      modal: false,
      locales: i18nextLng == "cs" ? cs : enGB,
      date: this.getCurrentDate()
    };

    this.toggle = this.toggle.bind(this);
    this.handleValidSubmit = this.handleValidSubmit.bind(this);
    this.getDate = this.getDate.bind(this);
  }

  toggle() {
    this.setState((prevState: any) => ({
      modal: !prevState.modal
    }));
  }

  getDate(datetime: string) {
    let date = {
      year: datetime.slice(0, 4),
      month: datetime.slice(5, 7),
      day: datetime.slice(8, 10)
    };
    return date.year + "-" + date.month + "-" + date.day;
  }

  makeTwoDigits(number: any) {
    return number.toString().length == 2 ? number : "0" + number;
  }

  getCurrentDate() {
    let date = new Date();
    console;
    return (
      date.getFullYear() +
      "-" +
      this.makeTwoDigits(date.getMonth() + 1) +
      "-" +
      this.makeTwoDigits(date.getDate())
    );
  }

  handleValidSubmit(event: any, values: any) {
    this.toggle();
    this.props.payOrder(this.props.id, this.state.date);
  }

  onDateChange(date: any) {
    this.setState({date})
  }

  getDateFromDate(datetime: any) {
    let date = {
      day: datetime.getDate(),
      month: datetime.getMonth() + 1,
      year: datetime.getFullYear()
    };

    date.month = date.month.toString().length == 1 ? "0" + date.month : date.month;
    date.day = date.day.toString().length == 1 ? "0" + date.day : date.day;
    return date.year + "-" + date.month + "-" + date.day;
  }
  
  render() {
    const {t} = this.props;

    return (
      <div>

        {this.props.icon ?
          <Button color="success"
            onClick={this.toggle}
          >

          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
          <path fill="#ffffff" d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1.41 16.09V20h-2.67v-1.93c-1.71-.36-3.16-1.46-3.27-3.4h1.96c.1 1.05.82 1.87 2.65 1.87 1.96 0 2.4-.98 2.4-1.59 0-.83-.44-1.61-2.67-2.14-2.48-.6-4.18-1.62-4.18-3.67 0-1.72 1.39-2.84 3.11-3.21V4h2.67v1.95c1.86.45 2.79 1.86 2.85 3.39H14.3c-.05-1.11-.64-1.87-2.22-1.87-1.5 0-2.4.68-2.4 1.64 0 .84.65 1.39 2.67 1.91s4.18 1.39 4.18 3.91c-.01 1.83-1.38 2.83-3.12 3.16z"/>
          <path fill="none" d="M0 0h24v24H0z"/>
          </svg>
          </Button>
        :
          <Button
            color="success"
            onClick={this.toggle}
            style={
              this.props.style
                ? this.props.style
                : { margin: "0 5px", float: "right" }
            }
          >
            {this.props.buttonLabel}
          </Button>
        }

        <Modal isOpen={this.state.modal} toggle={this.toggle}>
          <ModalHeader toggle={this.toggle}>{this.props.name}</ModalHeader>
          <ModalBody>
            <Row className="pb-2">
              <Col className="font-weight-bold">{t("variable_symbol")}</Col>
              <Col>{this.props.variableSymbol}</Col>
            </Row>
            <Row className="pb-2">
              <Col className="font-weight-bold">{t("price")}</Col>
              <Col>
                {this.props.price} {this.props.currency}
              </Col>
            </Row>
            <Row>
              <Col className="font-weight-bold">
                {t("payment_date")}
              </Col>
              <Col>
                <DatePicker
                  selected={this.state.date ? new Date(this.state.date) : new Date(this.getCurrentDate())}
                  onChange={date => this.onDateChange(this.getDateFromDate(date))}
                  dateFormat="PP"
                  locale={this.state.locales}
                  className="w-100 is-untouched is-pristine av-valid form-control"
                />
              </Col>
            </Row>
            <hr />
            <Row>
              <Col>
                {this.props.canceled && (
                  <Alert color="danger" style={{textAlign: "center"}}>{t("canceled_order_warning")}</Alert>
                )}
              </Col>
            </Row>
            <Row>
              <Col>
                <AvForm onValidSubmit={this.handleValidSubmit} style={{display: "flex", justifyContent: "center"}}>
                  <Button
                    color="success"
                    type="submit"
                    style={{ minWidth: "200px" }}
                  >
                    OK
                  </Button>
                </AvForm>
              </Col>
            </Row>
          </ModalBody>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = (state: any) => {
  return {
    order: state.order
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return bindActionCreators(
    {
      payOrder: orderAction.payOrder
    },
    dispatch
  );
};

const PayOrderModalComponent = compose(
  withTranslation('orders'),
  connect(mapStateToProps, mapDispatchToProps)
  )(PayOrderModal);

export { PayOrderModalComponent as PayOrderModal };
